import { HexContainer } from '../hex-container/hex-container';
import DefaultHexImage from '../../../../assets/face-user.svg?react';
import './enrollment-header.less';
import {
  Banner,
  type BannerProps,
} from '../../../Banner/banner';
import FaceBioWarningImg from '../../../../assets/face-bio-orange.svg?react';
import FaceBioErrorImg from '../../../../assets/face-bio-red.svg?react';
import type { NotificationBannerProps } from 'src/components/notificationBanner/NotificationBanner';

interface EnrollmentHeaderProps {
  hexImage?: React.ReactNode;
  banner?: NotificationBannerProps;
}

export const EnrollmentHeader = ({
  hexImage = <DefaultHexImage />,
  banner,
}: EnrollmentHeaderProps) => {
  const renderImage = () => {
    switch (banner?.type) {
      case 'error':
        return <FaceBioErrorImg />;
      case 'warning':
        return <FaceBioWarningImg />;
      default:
        return hexImage;
    }
  };
  return (
    <div className={`enrollment-header ${banner ? banner.type : ''}`}>
      {banner && <Banner status={banner.type as BannerProps['status']} message={banner?.message} subMessage={banner?.description} className="enroll-banner" />}
      <HexContainer className="authn-layout-header-hex" icon={renderImage()} />
    </div>
  );
};
